import { string } from 'prop-types';

const TrailsIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>trail-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -200) translate(70 200)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                d="M12 3c-3.925 0-7 3.085-7 7.023 0 5.276 5.278 9.519 7 10.762 1.722-1.243 7-5.486 7-10.762C19 6.085 15.925 3 12 3m0 20c-.186 0-.371-.052-.535-.155C11.119 22.626 3 17.402 3 10.023 3 4.963 6.953 1 12 1c5.047 0 9 3.963 9 9.023 0 7.379-8.119 12.603-8.465 12.822-.164.103-.349.155-.535.155"
                transform="translate(8 8)"
              />
              <path d="M12 12c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2" transform="translate(8 8)" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

TrailsIcon.propTypes = {
  className: string
};

TrailsIcon.defaultProps = {
  className: ''
};

export default TrailsIcon;
